/**
 * salesScreenDataService — satis ekranlarini (Hizli Satis + PYK) SQL'den okur (Faz B).
 *
 * Eski `getCompanyData(companyId, 'quickSaleScreens')` / `getCompanyData(companyId, 'pykscreen')`
 * karsiligi. Kaynak:
 *   - Hizli Satis: salesService.getQuickSaleScreens()  (GET /api/QuickSaleScreen)
 *   - PYK/POS:     salesService.getPykScreens()         (GET /api/PykScreen)
 *
 * KULLANIM: Donen liste, islem kayitlarinda saklanan `screenName` yoksa
 *           isim-arama YEDEGI olarak kullanilir (islem `screenId` ile eslestirilir).
 *
 * NOT: RTDB `pos_devices` (POS odeme cihaz tanimlari) icin temiz bir SQL ucu YOK
 *      (api/Device/list dijital-tabela/kiosk ekranlaridir, farkli bir kavram).
 *      Bu eski-yontem dugumu bilerek DAHIL EDILMEZ; islem kaydindaki screenName birincil kaynaktir.
 */

import salesService from '../salesService';

export interface SalesScreenOption {
  /** SQL ekran kimligi (string'e cevrilmis integer Id). */
  id: string;
  name: string;
  type: 'quicksale' | 'pos';
  isActive: boolean;
}

/**
 * Hizli Satis + PYK ekranlarini birlestirip isme gore sirali dondurur.
 * companyId X-Company-Id header'indan gelir (parametre yalniz imza uyumu icin).
 */
export async function getSalesScreenOptions(_companyId?: string): Promise<SalesScreenOption[]> {
  const [quickSale, pyk] = await Promise.all([
    salesService.getQuickSaleScreens().catch(() => []),
    salesService.getPykScreens().catch(() => []),
  ]);

  const options: SalesScreenOption[] = [];

  for (const s of quickSale || []) {
    if (s?.Name) {
      options.push({ id: String(s.Id), name: `${s.Name} (Hızlı Satış)`, type: 'quicksale', isActive: true });
    }
  }

  for (const p of pyk || []) {
    if (p?.Name && p.IsActive !== false) {
      options.push({ id: String(p.Id), name: `${p.Name} (POS)`, type: 'pos', isActive: p.IsActive !== false });
    }
  }

  options.sort((a, b) => a.name.localeCompare(b.name));
  return options;
}
